import React, { useState } from "react";
import FormWrapper from "../../components/Common/FormWrapper";
import showToast from "../../utils/toastNotifications";

const TaxConsulation = () => {
  const [description, setDescription] = useState("");
  const [touched, setTouched] = useState(false);

  const handleLegalSubmit = () => {
    setTouched(true);

    if (!description.trim()) {
      showToast("error", "Please provide a reason for contact.");
      return;
    }

    showToast("success", "Tax consultation request submitted.");
  };

  return (
    <div className="bg-diagonal-sky w-full min-h-screen">
      <div className="p-4 sm:p-[20px] md:p-[24px] lg:p-[30px] flex justify-center">
        <div className="w-full ">
          <FormWrapper
            wrapperHeight="h-[510px] sm:h-[524px] md:h-[530px] lg::h-[534px]"
            showDropdown={false}
            textareaLabel="Reason for Contact"
            textareaPlaceholder="Describe your tax concern..."
            textareaValue={description}
            onTextareaChange={(e) => {
              setDescription(e.target.value);
              if (!touched) setTouched(true);
            }}
            textareaError={
              touched && !description.trim() ? "This field is required." : ""
            }
            buttonLabel="Request Tax Consultation"
            onSubmit={handleLegalSubmit}
            required
          />
        </div>
      </div>
    </div>
  );
};

export default TaxConsulation;

